<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-row justify="center" class="pt-8" no-gutters>
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
          <v-row justify="center">
            <v-col cols="12" class="mt-n5 mb-2">
              <v-radio-group v-model="type" hide-details>
                <v-row justify="center">
                  <v-col cols="6" class="mt-n5">
                    <v-radio value="single" label="¿Misma fórmula en los dos ojos?"></v-radio>
                  </v-col>
                  <v-col cols="6" class="mt-n5">
                    <v-radio value="multiple" label="¿Diferente fórmula para cada ojo?"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>
            <template v-if="type === 'single'">
             <v-col cols="12" v-if="getSphereValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.sphere"
                  :items="getSphereValues"
                  item-text="name"
                  item-value="key"
                  label="Esfera"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="getCylinderValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.cylinder"
                  :items="getCylinderValues"
                  item-text="name"
                  item-value="key"
                  label="Cilindro"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="getAxisValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.axis"
                  :items="getAxisValues"
                  item-text="name"
                  item-value="key"
                  label="Eje"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="getAddictionValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.addiction"
                  :items="getAddictionValues"
                  item-text="name"
                  item-value="key"
                  label="Adición"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="!!_product.variation_theme">
                <v-select class="mt-n4"
                  v-model="variant"
                  :items="_product.variants"
                  item-text="name"
                  :label="getProductVariantConfig.name"
                  :rules="[isRequired]"
                  :hint="getProductVariantConfig.hint"
                  @change="changeVariant"
                  persistent-hint
                  solo
                  return-object>
                </v-select>
              </v-col>

              <v-col cols="12">
                <v-select class="mt-n4"
                  v-model.number="quantity.left"
                  :items="getProductQuantities"
                  item-text="value"
                  item-value="quantity"
                  label="Cantidad"
                  :rules="[isRequired, isNumeric]"
                  :hint="getQuantityHint"
                  :disabled="getProductQuantities.length === 0"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
            </template>

            <template v-if="type === 'multiple'">
              <v-col cols="6" v-if="getSphereValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.sphere"
                  :items="getSphereValues"
                  item-text="name"
                  item-value="key"
                  label="Esfera ojo izquierdo"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
              <v-col cols="6" v-if="getSphereValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.right.sphere"
                  :items="getSphereValues"
                  item-text="name"
                  item-value="key"
                  label="Esfera ojo derecho"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="6" v-if="getCylinderValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.cylinder"
                  :items="getCylinderValues"
                  item-text="name"
                  item-value="key"
                  label="Cilindro ojo izquierdo"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
              <v-col cols="6" v-if="getCylinderValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.right.cylinder"
                  :items="getCylinderValues"
                  item-text="name"
                  item-value="key"
                  label="Cilindro ojo derecho"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="6" v-if="getAxisValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.axis"
                  :items="getAxisValues"
                  item-text="name"
                  item-value="key"
                  label="Eje ojo izquierdo"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
              <v-col cols="6" v-if="getAxisValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.right.axis"
                  :items="getAxisValues"
                  item-text="name"
                  item-value="key"
                  label="Eje ojo derecho"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="6" v-if="getAddictionValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.left.addiction"
                  :items="getAddictionValues"
                  item-text="name"
                  item-value="key"
                  label="Adición ojo izquierdo"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
              <v-col cols="6" v-if="getAddictionValues.length > 0">
                <v-select class="mt-n4" v-model.number="formula.right.addiction"
                  :items="getAddictionValues"
                  item-text="name"
                  item-value="key"
                  label="Adición ojo derecho"
                  hint="Requerido"
                  :rules="[isRequiredNumeric]"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>

              <v-col cols="6" v-if="!!_product.variation_theme">
                <v-select class="mt-n4"
                  v-model="variant"
                  :items="_product.variants"
                  item-text="name"
                  :label="getProductVariantConfig.name"
                  :rules="[isRequired]"
                  :hint="getProductVariantConfig.hint"
                  @change="changeVariant"
                  persistent-hint
                  solo
                  return-object>
                </v-select>
              </v-col>
              <v-col cols="6" v-if="!!_product.variation_theme">
                <v-select class="mt-n4"
                  v-model="variant"
                  :items="_product.variants"
                  item-text="name"
                  :label="getProductVariantConfig.name"
                  :rules="[isRequired]"
                  :hint="getProductVariantConfig.hint"
                  @change="changeVariant"
                  persistent-hint
                  solo
                  return-object>
                </v-select>
              </v-col>

              <v-col cols="6">
                <v-select class="mt-n4"
                  v-model.number="quantity.left"
                  :items="getProductQuantities"
                  item-text="value"
                  item-value="quantity"
                  label="Cantidad"
                  :rules="[isRequired, isNumeric]"
                  :hint="getQuantityHint"
                  :disabled="getProductQuantities.length === 0"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select class="mt-n4"
                  v-model.number="quantity.right"
                  :items="getProductQuantities"
                  item-text="value"
                  item-value="quantity"
                  label="Cantidad"
                  :rules="[isRequired, isNumeric]"
                  :hint="getQuantityHint"
                  :disabled="getProductQuantities.length === 0"
                  persistent-hint
                  solo>
                </v-select>
              </v-col>
            </template>

            <v-col class="mt-n8" cols="12">
              <v-checkbox
                label="Confirmo que he usado lentes de contacto y pasé por la etapa de adaptación."
                color="primary"
                :rules="[isRequired]"
                hide-details>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-6" no-gutters>
        <v-col xl="5" lg="7" md="8" sm="10" cols="12" class="text-left">
          <v-alert border="right" colored-border type="warning" elevation="2">
            Recuerda que para poder comprar en {{ domain }} debes adjuntar una copia de la fórmula médica o prescripción entregada por tu optómetra u oftalmólogo. Esta copia sera solicitada antes de realizar el pago.
          </v-alert>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-6" no-gutters>
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
          <v-row justify="end" no-gutters class="ml-lg-7 ml-xl-7">
            <v-col xl="6" lg="6" md="12" sm="12" cols="12">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :dark="valid" @click="validate" :disabled="!valid">
                Añadir al carrito
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { FORMULA_SPHERE_NAME, FORMULA_CYLINDER_NAME, FORMULA_AXIS_NAME, FORMULA_ADDICTION_NAME } from '@/shared/formula'
import { isRequired, isNumeric, isRequiredNumeric } from '@/shared/validations'
import { PAGE_DOMAIN } from '@/config/local-info'

export default {
  name: 'FormulaForm',
  data () {
    return {
      isRequired,
      isNumeric,
      isRequiredNumeric,
      type: 'single',
      formula: {
        left: {
          [FORMULA_SPHERE_NAME]: null,
          [FORMULA_CYLINDER_NAME]: null,
          [FORMULA_AXIS_NAME]: null,
          [FORMULA_ADDICTION_NAME]: null
        },
        right: {
          [FORMULA_SPHERE_NAME]: null,
          [FORMULA_CYLINDER_NAME]: null,
          [FORMULA_AXIS_NAME]: null,
          [FORMULA_ADDICTION_NAME]: null
        }
      },
      quantity: {
        left: 1,
        right: 1
      },
      variant: null,
      valid: true,
      domain: PAGE_DOMAIN
    }
  },
  computed: {
    ...mapState('product', ['_product']),
    ...mapGetters('product', ['getProductVariantConfig', 'getSphereValues', 'getCylinderValues', 'getAxisValues', 'getAddictionValues', 'getProductQuantities']),
    getQuantityHint () {
      const quantity = this.getProductQuantities.length
      if (!quantity) {
        return this.getProductVariantConfig.hint_disabled_quantity
      }

      return quantity === 1 ? quantity + ' Unidad disponible' : quantity + ' Unidades disponibles'
    }
  },
  methods: {
    ...mapMutations('product', ['setVariant']),
    changeVariant (variant) {
      this.setVariant(variant)
    },
    validate () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.$emit('close', { type: this.type, formula: this.formula, quantity: this.quantity, variant: this.variant })
      this.quantity = { left: 1, right: 1 }
      this.variant = null
      this.formula = {
        left: {
          [FORMULA_SPHERE_NAME]: null,
          [FORMULA_CYLINDER_NAME]: null,
          [FORMULA_AXIS_NAME]: null,
          [FORMULA_ADDICTION_NAME]: null
        },
        right: {
          [FORMULA_SPHERE_NAME]: null,
          [FORMULA_CYLINDER_NAME]: null,
          [FORMULA_AXIS_NAME]: null,
          [FORMULA_ADDICTION_NAME]: null
        }
      }

      this.$refs.form.resetValidation()
    }
  }
}
</script>
